import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme";

import { useDispatch, useSelector } from "react-redux";
import { unsetError } from "../services/actions";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ErrorDialog(props) {
  // const [open, setOpen] = React.useState(false);
  const diapch = useDispatch();
  const openwd = useSelector((state) => state.error);

  const handleClose = React.useCallback(() => {
    // props.open = false
    diapch(unsetError());
  }, [openwd]);

  return (
    <div>
      <Dialog
        open={openwd.error}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {/* <DialogTitle style={{fontSize:'0.8rem'}}>{props.data.primary}</DialogTitle> */}
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            style={{ fontSize: "0.6rem" }}
          >
            {/* {props.data.secondary} */}
            {/* Error Occured,Please refresh the page */}
            {openwd.message}
          </DialogContentText>
        </DialogContent>
        <ThemeProvider theme={theme}>
          <DialogActions>
            <Button color="neutral" onClick={handleClose}>
              Okay
            </Button>
          </DialogActions>
        </ThemeProvider>
      </Dialog>
    </div>
  );
}
